export default function Info() {
    return (
        <div className='container p-4'>
             <h1 className="mb-5 text-start">Información sobre esta página</h1>
             <h2 className="h4 mb-3">¿Qué es dniseguro.es?</h2>
             <p className="mb-3">Esta herramienta permite añadir algunas protecciones antes de compartir una copia digital de tu DNI con terceros.</p>
             <p className="mb-4">Inspirada en recomendaciones de distintas webs y artículos sobre privacidad y seguridad en internet.</p>
             <h2 className="h4 mb-3">Privacidad y seguridad</h2>
             <p className="mb-3">100% seguro. No se guarda ni se envia ningún dato personal fuera de tu dispotivo. La detección de cara, pixelado, etc... se procesa en tu navegador.</p>
             <p className="text-muted">Este sitio web usa Google Analytics con finalidades de mejora y observabilidad.</p>
        </div>
       
    )
}